import { useEffect, useMemo } from "react";
import {
  Routes,
  Route,
} from "react-router-dom";
import WebApp from "@twa-dev/sdk";

import AuthContext from "../context/auth.context";
import useAuth from "../hooks/auth.hook";
import DashboardPage from "./DashboardPage";
import OrderDetailPage from "./orders/OrderDetailPage";
import CreateSoldOrderPage from "./orders/CreateSoldOrderPage";
import TgChannelLayout, { TgChannelHomeRedirect } from "./TgChannelLayout";
import "../app/App.css";

function MissingBranch() {
  return (
    <p>
      Укажите канал и филиал в адресе, например /-1001234567890/branch/1
    </p>
  );
}

function AppRoutes({ authReady }) {
  return (
    <Routes>
      <Route
        path="/:tgChannelId"
        element={<TgChannelLayout authReady={authReady} />}
      >
        <Route index element={<TgChannelHomeRedirect />} />
        <Route
          path="branch/:branchId"
          element={<DashboardPage />}
        />
        <Route
          path="branch/:branchId/orders/:orderId"
          element={<OrderDetailPage />}
        />
        <Route
          path="branch/:branchId/orders/create"
          element={<CreateSoldOrderPage />}
        />
      </Route>
      <Route path="*" element={<MissingBranch />} />
    </Routes>
  );
}

function setupTelegramWebApp() {
  const calls = [
    () => WebApp.ready(),
    () => WebApp.expand(),
    () => WebApp.disableVerticalSwipes(),
    () => WebApp.enableClosingConfirmation(),
    () => WebApp.requestFullscreen(),
  ];
  for (const call of calls) {
    try {
      call();
    } catch (_) {
      // Older Telegram clients may not support every WebApp method.
    }
  }
}

function App() {
  useEffect(() => {
    setupTelegramWebApp();
  }, []);

  const { token, login, logout, ready } = useAuth();
  const authContextValue = useMemo(
    () => ({
      token,
      login,
      logout,
      isAuthenticated: !!token,
    }),
    [token, login, logout]
  );

  return (
    <AuthContext.Provider value={authContextValue}>
      <div className="app">
        <AppRoutes authReady={ready} />
      </div>
    </AuthContext.Provider>
  );
}

export default App;
